import axios from "axios";
import React, {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from "react";
import { ISSQN } from "../Components/Boleto/GerarForm";
import { Loader } from "../Components/Loader";
import { Alert } from "../Components/Modal/Alert";
import { Empresa } from "../Hooks/UsuarioHook";
import { useUsuarioPrefeitura } from "../Hooks/UsuarioPrefeituraHook";
import { API } from "../Services/Api";
import { useSeletor } from "./seletor";
import { useUsuarioNaoEmiteNota } from "../Hooks/UsuarioNaoEmiteNotaHook";

interface IIssqnContextData {
  empresaFocus: Empresa;
  setEmpresaFocus: React.Dispatch<React.SetStateAction<Empresa>>;
  loading: boolean;
  issqnInformado: IssqnInformado[];
  issqnInformadoFiltrado: IssqnInformado[];
  verificaPorPeriodoEFornecedor(
    periodo: string,
    fornecedor: number,
    prefeitura: boolean
  ): Promise<any[]>;
  postIssqnInformado(issqn: ISSQN, prefeitura: boolean): Promise< number>;
  corrigeCodigoBarras(id: number, codigo: string): Promise<void>;
  periodoInicial: {
    mes: number;
    ano: number;
  };
  periodoFinal: {
    mes: number;
    ano: number;
  };
  setPeriodoInical: React.Dispatch<
    React.SetStateAction<{
      mes: number;
      ano: number;
    }>
  >;
  setPeriodoFinal: React.Dispatch<
    React.SetStateAction<{
      mes: number;
      ano: number;
    }>
  >;
  colunas: ColunasListagem;
  setColunas: React.Dispatch<React.SetStateAction<ColunasListagem>>;
  helpColumn: string;
  setHelpColumn: React.Dispatch<string>;
  ordenacao: Order;
  setOrdenacao: React.Dispatch<React.SetStateAction<Order>>;
  handleOrdenacao(
    tipo:
      | "PERIODO"
      | "STATUS"
      | "BASE"
      | "STATUS"
      | "ISSQN"
      | "INFORMANTE"
      | "DATA_INFORMACAO"
      | "MOTIVO"
      | "VENCIMENTO"
      | "CODIGO"
      | "BASE_CALCULADA"
      | "VALOR_CALCULADO"
      | "DESCRICAO"
  ): void;
  getIssqnInformado(periodo: string, periodoFinal: string): Promise<void>;
}

interface IIssqnProviderProps {
  children: ReactNode;
}

const IssqnContext = createContext({} as IIssqnContextData);

export interface ColunasListagem {
  PERIODO: boolean;
  STATUS: boolean;
  BASE: boolean;
  ISSQN: boolean;
  INFORMANTE: boolean;
  DATA_INFORMACAO: boolean;
  MOTIVO: boolean;
  VENCIMENTO: boolean;
  CODIGO: boolean;
  VALOR_CALCULADO: boolean;
  BASE_CALCULADA: boolean;
}

export interface Order {
  PARAMETRO:
    | "PERIODO"
    | "STATUS"
    | "BASE"
    | "ISSQN"
    | "INFORMANTE"
    | "DATA_INFORMACAO"
    | "MOTIVO"
    | "VENCIMENTO"
    | "CODIGO"
    | "VALOR_CALCULADO"
    | "BASE_CALCULADA"
    | "DESCRICAO";

  ORDER: 1 | -1;
}

function IssqnProvider({ children }: IIssqnProviderProps) {
  const {usuarioNaoEmiteNota} = useUsuarioNaoEmiteNota();
  const { usuarioPrefeitura } = useUsuarioPrefeitura();
  const { pagos, pendentes } = useSeletor();
  const [empresaFocus, setEmpresaFocus] = React.useState({} as Empresa);
  const [issqnInformado, setIssqnInformado] = React.useState(
    [] as IssqnInformado[]
  );
  const [issqnInformadoFiltrado, setIssqnInformadoFiltrado] = React.useState(
    [] as IssqnInformado[]
  );
  const [ordenacao, setOrdenacao] = useState({
    ORDER: -1,
    PARAMETRO: "PERIODO",
  } as Order);
  const [colunas, setColunas] = React.useState({
    PERIODO: true,
    STATUS: true,
    BASE: true,
    ISSQN: true,
    INFORMANTE: true,
    DATA_INFORMACAO: true,
    MOTIVO: true,
    VENCIMENTO: true,
    CODIGO: true,
    BASE_CALCULADA: true,
    VALOR_CALCULADO: true,
  } as ColunasListagem);

  const [helpColumn, setHelpColumn] = useState("");

  const [alert, setAlert] = useState({ titulo: "", mensagem: "" });
  const [loading, setLoading] = useState(false);

  const [periodoInicial, setPeriodoInical] = useState({ mes: 0, ano: 0 });
  const [periodoFinal, setPeriodoFinal] = useState({ mes: 0, ano: 0 });

  function handleOrdenacao(
    tipo:
      | "PERIODO"
      | "STATUS"
      | "BASE"
      | "STATUS"
      | "ISSQN"
      | "INFORMANTE"
      | "DATA_INFORMACAO"
      | "MOTIVO"
      | "VENCIMENTO"
      | "CODIGO"
      | "BASE_CALCULADA"
      | "VALOR_CALCULADO"
      | "DESCRICAO"
  ) {
    setOrdenacao({ ORDER: ordenacao.ORDER == 1 ? -1 : 1, PARAMETRO: tipo });
    helpTimeOut();
  }

  function ordenar() {
    const lista_ordenada = issqnInformadoFiltrado.sort((a, b) => {
      let order_:
        | "PERIODO"
        | "COMPUTADA"
        | "BASE"
        | "ISSQN"
        | "CPFINFORMANTE"
        | "DATA_INFORMACAO"
        | "MOTIVO"
        | "VENCIMENTO"
        | "BASE_CALCULADA"
        | "VALOR_CALCULADO"
        | "DESCRICAO"
        | "CODBARRA" = "PERIODO";
      if (ordenacao.PARAMETRO == "STATUS") {
        order_ = "COMPUTADA";
      }
      if (ordenacao.PARAMETRO == "INFORMANTE") {
        order_ = "CPFINFORMANTE";
      }
      if (ordenacao.PARAMETRO == "CODIGO") {
        order_ = "CODBARRA";
      }

      if (
        ordenacao.PARAMETRO != "STATUS" &&
        ordenacao.PARAMETRO != "INFORMANTE" &&
        ordenacao.PARAMETRO != "CODIGO"
      ) {
        order_ = ordenacao.PARAMETRO;
      }
      if (ordenacao.PARAMETRO == "PERIODO") {
        order_ = "DATA_INFORMACAO";
      }

      if (a[order_] > b[order_]) return ordenacao.ORDER;
      if (a[order_] < b[order_]) return -ordenacao.ORDER;
      return 0;
    });

    setIssqnInformadoFiltrado([...lista_ordenada]);
    helpTimeOut();
  }
  useEffect(() => {
    ordenar();
  }, [ordenacao]);

  useEffect(() => {
    filtraIssqnInformado();
  }, [issqnInformado]);

  useEffect(() => {
    //estranho
    filtraIssqnInformado();
  }, [issqnInformadoFiltrado]);

  function filtraIssqnInformado() {
    try {
      if (
        periodoInicial.mes != 0 &&
        periodoInicial.ano != 0 &&
        periodoFinal.mes != 0 &&
        periodoInicial.ano != 0
      ) {
        let filtro = issqnInformado.filter(
          (item) =>
            new Date(item.DATA_INFORMACAO).getMonth() + 1 >=
              periodoInicial.mes &&
            new Date(item.DATA_INFORMACAO).getFullYear() >=
              periodoInicial.ano &&
            new Date(item.DATA_INFORMACAO).getMonth() + 1 <= periodoFinal.mes &&
            new Date(item.DATA_INFORMACAO).getFullYear() <= periodoFinal.ano
        );

        filtro = issqnInformado;
        if (pagos) {
          filtro = issqnInformado.filter((item) => item.COMPUTADA == "P");
        }
        if (pendentes) {
          filtro = issqnInformado.filter((item) => item.COMPUTADA != "P");
        }

        setIssqnInformadoFiltrado((prev) => filtro);
      } else {
        let filtro: IssqnInformado[] = issqnInformado;
        if (pagos) {
          filtro = issqnInformado.filter((item) => item.COMPUTADA == "P");
        }
        if (pendentes) {
          filtro = issqnInformado.filter((item) => item.COMPUTADA != "P");
        }

        setIssqnInformadoFiltrado((prev) => filtro);
      }
    } catch (e) {
      console.log(e);
      //window.alert("aqui: " + JSON.stringify(issqnInformado));
      setIssqnInformado([]);
    } finally {
    }
  }

  useEffect(() => {
    ordenar();
  }, [issqnInformado, periodoInicial, periodoFinal, pagos, pendentes]);

  async function getIssqnInformado(periodo?: string, periodoFinal?: string) {
    if (!periodo ) {
      periodo = new Date().getMonth().toString().padStart(2,'0')+"-"+new Date().getFullYear().toString();
    }
    if (!periodoFinal ) {
      periodoFinal = new Date().getMonth().toString().padStart(2,'0')+"-"+new Date().getFullYear().toString();
    }
  

    try {
      setLoading(true);
      setIssqnInformado([]);
      const { data } = await API.get(
        window.location.href.indexOf("/geral") != -1
          ? `/issqn-informado/periodo/${periodo}/periodoFinal/${periodoFinal}/${
              usuarioPrefeitura.usuario ? "" : "responsavel"
            }`
          : `/issqn-informado/${
              usuarioPrefeitura.usuario ? "prefeitura" : "fornecedor"
            }/${
              empresaFocus.CODIGO_FIRMA||usuarioNaoEmiteNota.CODIGO
            }/periodo/${periodo}/periodoF/${periodoFinal}`
      );

      setIssqnInformado(data);
    } catch (e) {
      //setIssqnInformado([]);
    } finally {
      setLoading(false);
    }
  }

  async function postIssqnInformado(issqn: ISSQN, prefeitura: boolean) {
    try {
      setLoading(true);
    
     const { data } = await API.post(
       `/issqn-informado/${prefeitura ? "prefeitura" : ""}`,
       issqn
     );
     //TENHO Q RETORNAR O ID GHERADO PARA PODER CORRIGIR O CODIGO DE BARRAS COM UMA CHAVE UNICA!
     return data[0].ID;
      
    } catch (e) {
      return 0;
    
    } finally {
      setLoading(false);
      getIssqnInformado();
    }
  }

  async function verificaPorPeriodoEFornecedor(
    periodo: string,
    fornecedor: number,
    prefeitura: boolean
  ) {
    try {
      setLoading(true);
      const { data } = await API.post(
        `/issqn-informado/${
          prefeitura ? "prefeitura" : "fornecedor"
        }/periodo-fornecedor`,
        { periodo, fornecedor }
      );
      return data;
    } catch (e) {
      window.alert("NÃO FOI POSSÍVEL INFORMAR O ISSQN");
    } finally {
      setLoading(false);
    }
  }

  async function corrigeCodigoBarras(id: number, codigo: string) {
    try {
      setLoading(true);
      const { data } = await API.put(
        `/issqn-informado/${usuarioPrefeitura.usuario ? "/prefeitura" : ""}`,
        { id, codigo }
      );
       
      getIssqnInformado();
    } catch (e) {
      window.alert("NÃO FOI POSSÍVEL INFORMAR O ISSQN");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    if (empresaFocus.CODIGO_FIRMA) {
      //window.alert(JSON.stringify(empresaFocus));
      getIssqnInformado();
    }
  }, [empresaFocus]);

  async function helpTimeOut() {
    setLoading(true);
    await new Promise((r) => setTimeout(r, 1));
    setLoading(false);
  }
  useEffect(() => {
    helpTimeOut();
  }, [colunas, helpColumn]);

  return (
    <IssqnContext.Provider
      value={{
        empresaFocus,
        setEmpresaFocus,
        loading,
        issqnInformado,
        postIssqnInformado,
        periodoFinal,
        periodoInicial,
        setPeriodoFinal,
        setPeriodoInical,
        issqnInformadoFiltrado,
        colunas,
        setColunas,
        helpColumn,
        setHelpColumn,
        corrigeCodigoBarras,
        ordenacao,
        setOrdenacao,
        handleOrdenacao,
        getIssqnInformado,
        verificaPorPeriodoEFornecedor,
      }}
    >
      <>
        {children}

        <Loader loading={loading} />
        <Alert
          alert={alert}
          onClose={() => setAlert({ titulo: "", mensagem: "" })}
          open={alert.mensagem.length > 0}
        />
      </>
    </IssqnContext.Provider>
  );
}

function useIssqn() {
  const context = useContext(IssqnContext);

  return context;
}

export { IssqnProvider, useIssqn };

export interface IssqnInformado {
  DESCRICAO: string;
  ID: number;
  PERIODO: string;
  BASE: number;
  ISSQN: number;
  COMENTARIO: null;
  CPFINFORMANTE: string;
  DATA_INFORMACAO: string;
  CHAVE: string;
  FORNECEDOR: number;
  COMPUTADA: "P" | "N" | "S" | "C";
  CANCELADA: "N" | "S";
  MOTIVO: string;
  ID_EXPORTADO: number;
  TIPO: number;
  VENCIMENTO: string;
  REGISTRO: number;
  CODBARRA: string;
  BASE_CALCULADA: number;
  VALOR_CALCULADO: number;
}
